export const loadOptions = () => {
  // Read CSS custom properties
  const cssVar = (name: string, fallback: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;

  // ---------- build options from CSS tokens ----------
  const fontFace = cssVar('--font-face', 'Source Sans Pro');
  const nodeFontSize = parseInt(cssVar('--node-font-size', '13'), 10);
  const edgeFontSize = parseInt(cssVar('--edge-font-size', '12'), 10);

  const options = {
    autoResize: true,
    interaction: { hover: true, tooltipDelay: 50, zoomView: true },
    physics: {
      enabled: true,
      solver: 'forceAtlas2Based',
      stabilization: { iterations: 250, fit: true },
    },
    nodes: {
      shapeProperties: { useBorderWithImage: true },
      borderWidth: 3,
      font: {
        face: fontFace,
        size: nodeFontSize,
        color: cssVar('--node-label-color', '#333333'),
        strokeColor: '#fff',
        strokeWidth: 1.5,
      },
      color: {
        border: cssVar('--node-border', '#9fb3ff'),
        background: cssVar('--node-bg', '#ffffff'),
        highlight: {
          border: cssVar('--node-border-highlight', '#111111'),
          background: cssVar('--node-bg', '#ffffff'),
        },
        hover: {
          border: cssVar('--node-border-hover', '#cdd9ff'),
          background: cssVar('--node-bg', '#ffffff'),
        },
      },
    },
    edges: {
      smooth: false,
      width: 1,
      hoverWidth: 1.5,
      selectionWidth: 1.5,
      color: {
        color: cssVar('--edge-color', '#9aa3b2'),
        highlight: cssVar('--edge-color-hover', '#111111'),
        hover: cssVar('--edge-color-hover', '#111111'),
        opacity: 0.9,
      },
      font: { face: fontFace, size: edgeFontSize, color: cssVar('--node-label-color', '#333333') },
    },
  };

  return options;
};
